import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e80c67f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submit_form container-lg container-fluid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Submit a health priority need"),
  /*#__PURE__*/_createElementVNode("p", null, " Have you identified a health need or challenge that requires an innovative solution? ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditHealthPriorityNeed = _resolveComponent("EditHealthPriorityNeed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_EditHealthPriorityNeed)
  ]))
}